export enum TipoModalAssinaturaEnum {
  ORIENTACAO = 1,
  ADITIVO = 2,
  REDUCAO_CARENCIA = 3,
  DOCUMENTO_FINAL = 4
}

const descricao = new Map<TipoModalAssinaturaEnum, string>([
  [TipoModalAssinaturaEnum.ORIENTACAO, "Orientação"],
  [TipoModalAssinaturaEnum.ADITIVO, "odonto"],
  [TipoModalAssinaturaEnum.REDUCAO_CARENCIA, "unimed Fesp"],
  [TipoModalAssinaturaEnum.DOCUMENTO_FINAL, "Documento Final"],
]);

export class TipoModalAssinaturaDescription {
  static getDescricao(valor: TipoModalAssinaturaEnum): string {
    return descricao.get(valor) || '';
  }

  static getAll(): { valor: TipoModalAssinaturaEnum, descricao: string }[] {
    return Array.from(descricao.entries()).map(([valor, descricao]) => ({ valor, descricao }));
  }
}
